import React from 'react';

import { Typography, Grid } from '@material-ui/core';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';

import grandmaAndLady5 from '../assets/grandmaAndLady5.jpg';
import grandmaAndLady5M from '../assets/grandmaAndLady5M.jpg';

const useStyles = makeStyles((theme) => ({
  wrapper: {
    marginTop: '6.5rem',
    marginBottom: '6.5rem',
    [theme.breakpoints.down('sm')]: {
      marginTop: '2.5rem'
    }
  },
  textBox: {
    width: '65%',
    padding: '2.75rem 5.125rem ',
    borderTop: '1px black solid',
    borderBottom: '1px black solid',
    [theme.breakpoints.down('sm')]: {
      width: '86%',
      padding: '2rem 0'
    }
  },
  pg1: {
    marginTop: '1.5rem',
    [theme.breakpoints.down('sm')]: {
      marginTop: '1rem'
    }
  },
  linkSection: {
    marginTop: '1.5rem',
    padding: '4rem 0',
    [theme.breakpoints.down('sm')]: {
      marginTop: '1rem',
      width: '86%'
    }
  },
  bolded: {
    ...theme.typography.body2,
    [theme.breakpoints.down('sm')]: {
      fontSize: '16px',
      lineHeight: '28px'
    }
  },
  mobileH3: {
    [theme.breakpoints.down('sm')]: {
      fontSize: '18px',
      lineHeight: '18px'
    }
  },
  mobileBody1: {
    [theme.breakpoints.down('sm')]: {
      fontSize: '16px',
      lineHeight: '28px',
      letterSpacing: '.5px'
    }
  },
  caption: {
    marginTop: '5px'
  },
  link: {
    color: theme.palette.common.darkBlue,
    textDecoration: 'none',
    fontFamily: 'cnnSansMed',
    textAlign: 'center'
  },
  disclaimerCont: {
    marginTop: '6.25rem',
    width: '65%',
    borderTop: '1px solid black',
    padding: '3.125rem 5rem',
    [theme.breakpoints.down('sm')]: {
      width: '86%',
      padding: '2rem 0'
    }
  }
}));

const Navigating = () => {
  const classes = useStyles();
  const theme = useTheme();
  const matchesSM = useMediaQuery(theme.breakpoints.down('sm'));
  return (
    <Grid container direction="column" alignItems="center" className={classes.wrapper}>
      <Grid container direction="column" className={classes.textBox}>
        <Grid item className={classes.pg1}>
          <Typography variant="body1" className={classes.mobileBody1}>
            <span className={classes.bolded}>NIKKI:</span> Today I woke up and I was so excited – I
            just thought “I get to meet Pat?! Oh, my goodness!” And now I’m proud, I want to hold
            her hand like a friend because we have grown so close.
          </Typography>
        </Grid>
        <Grid item className={classes.pg1}>
          <Typography variant="body1" className={classes.mobileBody1}>
            <span className={classes.bolded}>PAT:</span> When you live alone – especially when you
            get older, you don’t always know who to ask. I am very proud of myself 'cause it's the
            first time in probably 10 years that I took a chance to do something unknown. This
            morning when I was praying, I said, well, we broke another chain. We're breaking chains
            here.
          </Typography>
        </Grid>
      </Grid>
      <Grid container direction="column" alignItems="center" className={classes.linkSection}>
        <Typography variant="body1" className={classes.mobileBody1}>
          To explore UnitedHealthcare plans in your area that offer Navigate4Me
          <sup style={{ fontSize: '12px' }}>TM</sup>, visit
        </Typography>
        <Typography variant="body1" className={classes.mobileBody1}>
          <a href="https://www.aarpmedicareplans.com/?WT.mc_id=8003294" className={classes.link}>
            UHCMedicareHealthPlans.com
          </a>
        </Typography>
      </Grid>
      <Grid container direction="column" alignItems="center">
        <img
          src={matchesSM ? grandmaAndLady5M : grandmaAndLady5}
          alt="grandma and lady hugging"
          style={{ width: '100%', marginTop: '6.25rem' }}
        />
        <Typography variant="caption" className={classes.caption}>
          Pat shows Nikki her big yard.
        </Typography>
      </Grid>
      <Grid container justifyContent="center" className={classes.disclaimerCont}>
        <Typography variant="caption">Benefits vary by plan.</Typography>
        <Typography variant="caption" style={{ textAlign: 'center', marginTop: '3rem' }}>
          Plans insured through UnitedHealthcare Insurance Company or one of its affiliated
          companies, a Medicare Advantage organization with a Medicare contract. Enrollment in the
          plan depends on the plan’s contract renewal with Medicare.
        </Typography>
        <Typography variant="caption" style={{ textAlign: 'center', marginTop: '3rem' }}>
          Y0066_210825_043437_M
        </Typography>
      </Grid>
    </Grid>
  );
};

export default Navigating;
